﻿import { EmailModel } from '../../enums/index';
import { IEmailEntityContract } from './email-entity-contract';
import { IEmailSendeeContract } from './email-sendee-contract';

export interface IEmailTemplateContract {
    id: number;
    emailModel: EmailModel;
    subject: string;
    body: string;
    senderContactId: number;
    entities: IEmailEntityContract[];
    sendees: IEmailSendeeContract[];
}
